import React from "react";
import {connect} from "react-redux";
import { bindActionCreators } from "redux";
import { nl2br } from "lib/format";
import Linkify from "react-linkify";

import {openURL} from "state/app/actions";
import { getNoticeByID, getGoToNoticeID } from "state/teachers/selectors";
import { setExpandedNotice } from "state/teachers/actions";

import Highlight from "components/Highlight";
import ExpandingBox from "components/teachers/ExpandingBox";
import LiveDate from "components/LiveDate";

import iconArts     from "components/assets/images/teachers/noticeboard/arts.svg";
import iconBars     from "components/assets/images/teachers/noticeboard/bars.svg";
import iconCalendar from "components/assets/images/teachers/noticeboard/calendar.svg";
import iconClock    from "components/assets/images/teachers/noticeboard/clock.svg";
import iconFootball from "components/assets/images/teachers/noticeboard/football.svg";
import iconHands    from "components/assets/images/teachers/noticeboard/hands.svg";
import iconMap      from "components/assets/images/teachers/noticeboard/map.svg";
import iconMessage  from "components/assets/images/teachers/noticeboard/message.svg";
import iconMusic    from "components/assets/images/teachers/noticeboard/music.svg";
import iconTrophy   from "components/assets/images/teachers/noticeboard/trophy.svg";

const iconFiles = new Map([
  [ "arts.svg",     iconArts     ],
  [ "bars.svg",     iconBars     ],
  [ "calendar.svg", iconCalendar ],
  [ "clock.svg",    iconClock    ],
  [ "football.svg", iconFootball ],
  [ "hands.svg",    iconHands    ],
  [ "map.svg",      iconMap      ],
  [ "message.svg",  iconMessage  ],
  [ "music.svg",    iconMusic    ],
  [ "trophy.svg",   iconTrophy   ]
]);

class Notice extends React.Component {

  linkifyProperties = {
    onClick: (clickEvent) => {
      this.props.openURL(clickEvent.target.href);
      clickEvent.preventDefault();
    }
  }

  expand = () => {
    this.props.setExpandedNotice(this.props.notice.get("id"));
  }
  collapse = () => {
    this.props.setExpandedNotice(null);
  }

  /**
   * If this notice is expanded, unset expandedNoticeID when it unmounts
   */
  componentWillUnmount() {
    if (this.props.notice.get("expanded")) {
      this.collapse();
    }
  }

  render() {

    const { notice, isHighlighted } = this.props;
    const { subject, icon, description, postedDate, timezoneOffset, expanded } = notice.toObject();

    return (
      <div className="notice" ref={this.props.innerRef}>
        <Highlight cssModifier="teachers" isHighlighted={isHighlighted}>
          <ExpandingBox onExpand={this.expand} onCollapse={this.collapse} expanded={expanded} >
            <ExpandingBox.Header toggleOnClick={true}>
              <div className="notice__header">
                <img className="notice__icon" src={iconFiles.get(icon)} alt="notice icon" />
                <div className="notice__header-text">
                  <div className="notice__subject">{subject}</div>
                  <div className="notice__post-date">
                    <LiveDate date={postedDate} timezoneOffset={timezoneOffset} />
                  </div>
                </div>
              </div>
            </ExpandingBox.Header>
            <ExpandingBox.Body toggleOnClick={true}>
              <div className="notice__body">
                <div className="notice__description">
                  <Linkify properties={this.linkifyProperties}>{nl2br(description)}</Linkify>
                </div>
              </div>
            </ExpandingBox.Body>
          </ExpandingBox>
        </Highlight>
      </div>
    );
  }
};

export default connect(
  (state, { noticeID }) => ({
    notice: getNoticeByID(state, noticeID),
    isHighlighted: getGoToNoticeID(state) === noticeID
  }),
  (dispatch) => bindActionCreators({
    setExpandedNotice,
    openURL
  }, dispatch)
)(Notice)



// WEBPACK FOOTER //
// ./src/components/teachers/noticeboard/Notice.js